/**
 * 向业务侧返回的sdk响应码
 * 业务侧可以按需根据具体的错误码来做相应处理
 */
export const SdkResponseCode = {
    /**
     * 通用 code
     */
    /**
     * 未实现
     * 用于明确通知外部当前环境下，该API未实现
     */
    Unimplemented: Symbol('SDK_UNIMPLEMENTED'),
    /**
     * 执行失败
     * 一般是第三方api调用返回失败结果了
     */
    ThirdPartyServiceFail: Symbol('SDK_THIRD_PARTY_SERVICE_FAIL'),
    /**
     * h5-jsapi包内部主动生成错误并抛出
     */
    H5JsApiError: Symbol('SDK_H5JSAPI_ERROR'),

    /**
     * api 相关 code
     */
    Init: {
        /**
         * 加载jssdk脚本时出错
         */
        LoadScriptError: Symbol('SDK_LOAD_SCRIPT_ERROR'),
        /**
         * 获取鉴权参数时出错
         */
        FetchConfigError: Symbol('SDK_FETCH_CONFIG_ERROR'),
        /**
         * jssdk鉴权时出错
         */
        SdkConfigError: Symbol('SDK_SDK_CONFIG_ERROR')
    },
    /**
     * 定位相关响应码
     */
    Location: {
        /**
         * 经纬度为空
         */
        LngOrLatEmpty: Symbol('SDK_LNG_OR_LAT_EMPTY'),
        /**
         * 定位超时
         */
        Timeout: Symbol('SDK_LOCATION_TIMEOUT')
    }
} as const;

/**
 * jssdk API 前缀标识
 */
export const JS_API_PREFIX = '[FX-JS-API]';
